export default __webpack_public_path__ + "static/Hero_mobile-8c516d577665a8233bff132dac307325.jpg";